.container {
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  .trigger {
    border: 1px solid var(--color-grayscale-trout);

    &:hover {
      border-color: var(--text-color-white);
    }
  }
}
